import React from 'react';
import { ConfigProvider } from 'antd';
import frFR from 'antd/es/locale/fr_FR';
import enGB from 'antd/es/locale/en_GB';
import { useTranslation } from 'react-i18next';

/** Composants antd (pagination, dialogues, sélecteurs de date, tableaux vides) dans la langue du back-office. */
export default function AppLocaleProvider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  return <ConfigProvider locale={i18n.language === 'en' ? enGB : frFR}>{children}</ConfigProvider>;
}
